import authenticate from "@/auth/authenticate";
import hasPermission from "@/auth/hasPermission";
import hasSelectedCompany from "@/auth/hasSelectedCompany";



export default [
  {
    path: "/",
    component: () => import("@/views/global/Index"),
    meta: { layout: "auth" },
    beforeEnter: authenticate,

    children: [
      {
        path: "",
        name: "admin.companySelector",
        meta: { layout: "VerticalSix", hiddenAppBar: false },
        component: () => import("@/views/admin/CompanySelector"),
      },
      {
        path: "admin",
        name: "admin.index",
        meta: { layout: "VerticalSix", hiddenAppBar: false },
        component: () => import("@/views/admin/Index"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/members",
        name: "admin.members",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 2 },
        component: () => import("@/views/admin/Members.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/technicians",
        name: "admin.technicians",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 2 },
        component: () => import("@/views/admin/Technicians.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/api-keys",
        name: "admin.api-keys",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 2097152 },
        component: () => import("@/views/admin/ApiKeys.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/organizations",
        name: "admin.organizations",
        beforeEnter: hasPermission,
        meta: {
          layout: "VerticalSix",
          permission: [1024, 2048],
        },
        component: () => import("@/views/admin/Organizations.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/organization/:id",
        name: "admin.organization.management",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: [1024, 2048] },
        component: () => import("@/views/admin/OrganizationManagement.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/fees",
        name: "admin.fees",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: [262144, 524288] },
        component: () => import("@/views/admin/Fees.vue"),
        beforeEnter: hasSelectedCompany,
      },

      // Financial
      {
        path: "admin/parties",
        name: "admin.parties",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 4096 },
        component: () => import("@/views/admin/Parties.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/platforms",
        name: "admin.platforms",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 4096 },
        component: () => import("@/views/admin/Platforms.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/platforms/:id",
        name: "admin.platforms.management",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 4096 },
        component: () => import("@/views/admin/PlatformManagement.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/platforms/create",
        name: "admin.platforms.create",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 4096 },
        component: () => import("@/views/admin/CreatePlatform.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/parties/:id",
        name: "admin.parties.management",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 4096 },
        component: () => import("@/views/admin/PartyManagement.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/messager",
        name: "admin.messager",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: [8192] },
        component: () => import("@/views/admin/Messager.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/campaigns",
        name: "admin.campaigns",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: [8192] },
        component: () => import("@/views/admin/Campaigns.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/campaigns/:id",
        name: "admin.campaigns.detail",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: [8192] },
        component: () => import("@/views/admin/CampaignDetail.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/financial/reports",
        name: "admin.financial.reports",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: [16, 32] },
        component: () => import("@/views/admin/financial/Reports.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/financial/transations",
        name: "admin.financial.transations",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 131072 },
        component: () => import("@/views/admin/financial/Transactions.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/registrations",
        name: "admin.registrations",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 131072 },
        component: () => import("@/views/admin/Registrations.vue"),
        beforeEnter: hasSelectedCompany,
      },
      {
        path: "admin/resource-request",
        name: "admin.resource-request",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: [8388608, 16777216] },
        component: () => import("@/views/admin/ResourceRequest.vue"),
      },
      {
        path: "admin/resource-request/create",
        name: "admin.resource-request.create",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 8388608 },
        component: () => import("@/views/admin/ResourceRequestCreate.vue"),
      },
      {
        path: "admin/resource-request/:id",
        name: "admin.resource-request.management",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: 8388608 },
        component: () => import("@/views/admin/ResourceRequestManagement.vue"),
      },
      {
        path: "admin/concession-request",
        name: "admin.concession-request",
        beforeEnter: hasPermission,
        meta: { layout: "VerticalSix", permission: [8388608, 16777216] },
        component: () => import("@/views/admin/ConcessionRequest.vue"),
      },

      {
        path: "*",
        redirect: "/",
      },
    ],
  },
];
